
    import VueRendererComponent from "client/src/renderers/vue-components/vue-renderer-component.vue";

    export default {
        name: "set-password",
        mixins: [VueRendererComponent],

        data: function () {
            return {
                userId: undefined,
                token: undefined,
                tokenError: undefined,
                password: undefined,
                passwordConfirm: undefined,
                passwordCurrent: undefined,
                error: undefined,
                success: undefined,
                showPassword: false,
                showPasswordConfirm: false
            }
        },

        methods: {
            togglePasswordVisibility() {
                this.showPassword = !this.showPassword;
            },

            toggleConfirmPasswordVisibility() {
                this.showPasswordConfirm = !this.showPasswordConfirm;
            },

            validatePassword(password) {
                const min = 8;

                if (!password || password.length < min) {
                    return `Password can not be less than ${min} chars.`;
                }

                if (!/[a-z]/.test(password)) {
                    return "Password must contain at least one lowercase letter [a-z].";
                }

                if (!/[A-Z]/.test(password)) {
                    return "Password must contain at least one uppercase letter [A-Z].";
                }

                if (!/\d/.test(password)) {
                    return "Password must contain at least one digit [0-9] .";
                }

                if (!/[^a-zA-Z0-9]/.test(password)) {
                    return "Password must contain at least one special character (not [a-z A-Z 0-9])";
                }

                return null;
            },

            validatePasswordField() {
                if (!this.password) {
                    this.error = null;
                    return;
                }

                const err = this.validatePassword(this.password);
                this.error = err;

                // confirm alanı doluysa onu da tekrar kontrol et
                if (!err && this.passwordConfirm) {
                    this.validateConfirmPassword();
                }
            },

            validateConfirmPassword() {
                if (!this.passwordConfirm) {
                    return;
                }

                if (this.passwordConfirm !== this.password) {
                    this.error = "Passwords do not match.";
                } else {
                    this.error = null;
                }
            },
            submit() {
                const passwordError = this.validatePassword(this.password);
                if (passwordError) {
                    this.error = passwordError;
                    return;
                }
                if (this.passwordConfirm !== this.password){
                    this.error = "Passwords do not match.";
                    return;
                }

                this.$emit('submit', {
                    userId: this.userId,
                    token: this.token,
                    newPassword: this.password,
                    password: this.passwordCurrent

                });
            },
            textChanged(event){
                if (this.error) this.error = null;
            }
        },
        computed: {
            isDisabled: function () {
                return !!this.success;
            },
            classObject: function () {
                return {
                    error: !!this.error || !!this.tokenError,
                    success: !!this.success
                }
            },
            showMessage: function () {
                return !!this.success || !!this.error || !!this.tokenError;
            }
        }

    }
